import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLogoutIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.0044 3v8.9987m5.6534-4.8233c1.1185 1.1327 1.8802 2.5758 2.1887 4.1468a8.19 8.19 0 0 1-.4557 4.6789c-.6056 1.4797-1.631 2.7444-2.9465 3.6342S13.5821 21 12 21s-3.1287-.4749-4.4443-1.3647c-1.3155-.8898-2.341-2.1545-2.9465-3.6342a8.19 8.19 0 0 1-.4557-4.6789c.3085-1.571 1.0702-3.014 2.1887-4.1468"
    />
  </svg>
);
export default SvgLogoutIcon;
